import validate from 'validate.js'
import _ from 'lodash'

const createRepElemMsgStructure = (repElemErr, repElemName, invIdx, idxLineItem, idxRepElem) => {
    return Object?.entries(repElemErr)?.reduce((repPrev, [repKey, repVal]) => {
        return {
            ...repPrev,
            [`invoice${invIdx + 1}_lineItem${idxLineItem + 1}_${repElemName}${idxRepElem + 1}_${repKey}`]:
                repVal[0] ? {
                    msg: `Invoice 00${invIdx + 1} :: LineItem 00${idxLineItem + 1} :: ${repElemName} 00${idxRepElem + 1}:: ${repVal[0]}`
                } : ""
        }
    }, {})
}

const createRepElemErrStructure = (repElemList, repElemName, repElemPattern, invIdx, idxLineItem) => {
    return repElemList?.reduce((repElemErrs, repElem, idxRepElem) => {
        let repElemErr = validate(repElem, repElemPattern) || {}
        repElemErr = createRepElemMsgStructure(repElemErr, repElemName, invIdx, idxLineItem, idxRepElem)
        return { ...repElemErrs, ...repElemErr }
    }, {})
}

const createLineItemMsgStructure = (lineItmErr, idx, idxLineItm) => {
    return Object?.entries(lineItmErr)?.reduce((liPrev, [liKey, liVal]) => {
        return {
            ...liPrev,
            [`invoice${idx + 1}_lineItem${idxLineItm + 1}_${liKey}`]:
                liVal[0] ? { msg: `Invoice 00${idx + 1} :: LineItem 00${idxLineItm + 1} :: ${liVal[0]}` } : ""
        }
    }, {})
}

const validateLineItems = (lineItems, validationPattern, idx,) => {
    return lineItems?.reduce((lineItmErrs, lineItm, idxLineItm) => {
        let lineItmErr = validate(lineItm, validationPattern?.lineItem()) || {}
        lineItmErr = createLineItemMsgStructure(lineItmErr, idx, idxLineItm)
        const additionalDocErrs = createRepElemErrStructure(lineItm?.additionalDoc, "additionalDoc", validationPattern?.additionalDoc(), idx, idxLineItm)
        const prevDocErrs = createRepElemErrStructure(lineItm?.prevDoc, "prevDoc", validationPattern?.prevDoc(), idx, idxLineItm)
        return { ...lineItmErrs, ...lineItmErr, ...additionalDocErrs, ...prevDocErrs }
    }, {})
}


const createInvoiceStructure = (invErr, idx) => {
    return Object?.entries(invErr)?.reduce((prev, [invKey, inVal]) => {
        return { ...prev, [`invoice${idx + 1}_${invKey}`]: inVal[0] ? { msg: `Invoice 00${idx + 1} :: ${inVal[0]}` } : "" }
    }, {})
}

const validateInvoices = (invoiceList, validationPattern) => {
    let errorList = invoiceList?.reduce((invErrs, inv, idx) => {
        let invErr = validate(inv, validationPattern?.invoice()) || {}
        invErr = createInvoiceStructure(invErr, idx)
        const lineItmErrs = validateLineItems(inv?.lineItems, validationPattern, idx)
        return { ...invErrs, ...invErr, ...lineItmErrs }
    }, {})

    return _.isEmpty(errorList) ? null : errorList
}

export {
    validateInvoices,
    createInvoiceStructure,
    createLineItemMsgStructure,
    createRepElemErrStructure,
    createRepElemMsgStructure
}